import {BaseEndpoints} from 'public-shared/models/endpoints/base-endpoint.constants';

export class ForgotPasswordEndpoints {
  public static readonly BASE = BaseEndpoints.V1 + 'forgot-password/';
  public static readonly RESET = 'reset/';
  public static readonly NEW = 'new/';
}
